import { API_URL, STATUS_PATH } from '../../environment';
  
  const StatusService = (transactionId, token) => {
    const _getStatus = async () => {
      const url = API_URL + STATUS_PATH + transactionId;
  
      try {
        debugger
        const response = await fetch(url, { method: 'GET',headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }, timeout: 5000 });
       
        const responseClone = response.clone();
        const text = await responseClone.text();
        console.log("RAW RESPONSE:", text);
        
          const responseBody = await response.json();
          return responseBody;
       
     
      } catch (error) {
        console.error(error);
      };
    };
  
    const _pollStatus = async (timeout = 300000, interval = 5000) => {
      const endTime = Number(new Date()) + timeout;
  
      const checkCondition = async (resolve, reject) => {
        // Get current status
        const currentResponse = await _getStatus();
        const currentStatus = currentResponse.status;
        if (currentStatus === 'Failed' || currentStatus === 'Partial Processing' || currentStatus === 'Partial Completed' || currentStatus === 'Completed' || currentStatus === 'Processing') {
          resolve(currentResponse);
        } else if (Number(new Date()) < endTime) {
          setTimeout(checkCondition, interval, resolve, reject);
        } else {
          reject(new Error(`Polling timed out!`));
        }
      };
  
      return new Promise(checkCondition);
    };
  
    return {
      getStatus: _getStatus,
      pollStatus: _pollStatus,
    };
  };
  
  export default StatusService;